import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { RebateRequestComponent } from 'src/app/front-user/services/long-haul/rebate-request/rebate-request.component';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import {RelatedRequests } from 'src/app/shared/models/circular.model';
import { TugsLongHaulRequestMeasurementCommitteeDecisionAccept, LongHaulRequestMeasurementCommitteeAccept, LongHaulRequestMeasurementCommitteeDecision, LongHaulRequest } from 'src/app/shared/models/long-haul.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Country } from 'src/app/front-user/shared/models/country.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { Router } from '@angular/router';
import { ErrorsEnum } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { DatePipe } from '@angular/common';
import { VesselType } from 'src/app/front-user/shared/models/vessel-type.modal';
//import { forEach } from '@angular/router/src/utils/collection';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-rebate-request-measurement-committee-decision',
  templateUrl: './rebate-request-measurement-committee-decision.component.html'
})

export class RebateRequestMeasurementCommitteeDecisionComponent implements OnInit {
  //#region Properties & Variables
  //Decision Properties
  public rebateSCNT: string = "";
  private decisionSelected: number = 0;
  private isAccept: boolean = false;
  private isRequireModification: boolean = false;
  private isReject: boolean = false;
  //Form Properties
  private measurementCommitteeDecisionForm: FormGroup;
  private yearBuiltMaxDate: Date = new Date(Date.now());
  private isRebateOnlastTransit: boolean = false;
  private isFormSubmitted: boolean = false;
  @ViewChild('measurementCommitteeDecision',{static: false}) measurementCommitteeDecisionControls: ElementRef;
  //Rebate Request Properties
  private rebateRequestId: string = "";
  @ViewChild('rebateRequest',{static: false}) rebateRequest: RebateRequestComponent;
  private sailDirections: SailDirection[] = [];
  //Lookup Properties
  private tugs: GenericLookup[] = [];
  private rates: GenericLookup[] = [];
  public vesselTypes: GenericLookup[] = [];
  //Submit Properties
  public isRequestSucceeded: boolean = false;
  private isSubmitEnabled: boolean = false;
  private measurementCommitteeDecisionObject;
  private submitMeasurementCommitteeDecisionResponseObject: ResponseObject = new ResponseObject();
  //Tugs
  private tugsLongHaulRequestMeasurementCommitteeDecisionAccept: TugsLongHaulRequestMeasurementCommitteeDecisionAccept[] = [];
  private numberOfTugs: number;
  private noOfLoadedLookups: number = 0;
  private noOfLoadingLookups: number = 4;
  //User Properties
  public currentUser: User = new User();
  //Measurement Accepted Rebate Request
  private getMeasurementAcceptedRebateRequestResponseObject: ResponseObject = new ResponseObject();
  //New / Display [Mode]
  public formMode: FormMode = FormMode.New;
  public longHaulRequestMeasurementCommitteeDecision: LongHaulRequestMeasurementCommitteeDecision = new LongHaulRequestMeasurementCommitteeDecision();
  public longHaulRequestMeasurementCommitteeAccept: LongHaulRequestMeasurementCommitteeAccept = new LongHaulRequestMeasurementCommitteeAccept();
  //events Properties
  @Output() measurementCommitteeDecisionLoadedFlag: EventEmitter<boolean> = new EventEmitter();
  //Define Rebate Component
  public countries: GenericLookup[] = [];
  public isDefineRebateAdmin: boolean = false;
  //Review Rebate Component
  public isReviewRebateComponent: boolean = false;
  //Related Requests
  //private showRelatedRequests: boolean = false;
  private shipIMONO: string = "";
  private getRelatedRequestsResponse: ResponseObject = new ResponseObject();
  public getRelatedRequestsObjects: RelatedRequests[] = [];
  //Edit Accepted Object
  private firstTimeAccept: boolean = false;
  public longHaulRequestMeasurementCommitteeAcceptLoaded: LongHaulRequestMeasurementCommitteeAccept = new LongHaulRequestMeasurementCommitteeAccept();
  private longHaulRequestMeasurementCommitteeAcceptLoadedResponseObject: ResponseObject = new ResponseObject();
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  //#endregion

  //#region Constructor
  constructor(private cookieService: CookieService, public datepipe: DatePipe, private formBuilder: FormBuilder, private lookupService: LookupService, private longHaulService: LongHaulService, private globalServices: GlobalServices, private cd: ChangeDetectorRef, private router: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
  }
  //#endregion

  //#region Events & Methods
  ngOnInit() {
    this.setDefaults();
  }
  onDecisionChange(): void {
    this.isFormSubmitted = false;
    if (!this.isSubmitEnabled)
      this.isSubmitEnabled = true;
    switch (this.measurementCommitteeDecisionForm.controls['LongHaulRequestMeasurementCommitteeDecisionId'].value) {
      case Decision.Accept:
        this.onAcceptDecision();
        break;
      case Decision.RequireModification:
        this.onRequireModificationDecision();
        break;
      case Decision.Reject:
        this.onRejectDecision();
        break;
      default:
        //Do Nothing
        break;
    }
  }
  onAcceptDecision(): void {
    if (!this.firstTimeAccept) {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      this.loadMeasurementDecisionAcceptRebateRequest();
    }
    this.measurementCommitteeDecisionForm.controls["RequireModificationNotesAndComments"].clearValidators();
    this.measurementCommitteeDecisionForm.controls["RejectionReason"].clearValidators();
    this.isAccept = true;
    this.isRequireModification = false;
    this.isReject = false;
  }
  onRequireModificationDecision(): void {
    this.measurementCommitteeDecisionForm.controls["RejectionReason"].clearValidators();
    this.measurementCommitteeDecisionForm.controls["RequireModificationNotesAndComments"].setValidators([Validators.required]);
    this.isAccept = false;
    this.isRequireModification = true;
    this.isReject = false;
  }
  onRejectDecision(): void {
    this.measurementCommitteeDecisionForm.controls["RequireModificationNotesAndComments"].clearValidators();
    this.measurementCommitteeDecisionForm.controls["RejectionReason"].setValidators([Validators.required]);
    this.isAccept = false;
    this.isRequireModification = false;
    this.isReject = true;
  }
  onRebateOnlastTransitChange(): void {
    if (JSON.parse(this.measurementCommitteeDecisionForm.controls["LongHaulRequestMeasurementCommitteeAccept"].get("RebateOnlastTransit").value)) {
      this.isRebateOnlastTransit = true;
    } else {
      this.measurementCommitteeDecisionForm.controls["LongHaulRequestMeasurementCommitteeAccept"].patchValue({
        RebateValue: "",
        PortOfOrigin: "",
        PortOfDestination: ""
      });
      this.isRebateOnlastTransit = false;
    }
  }
  validateSCNT=(control: FormControl) => {
    if(this.rebateRequest){
      let oldSCNT = parseInt(this.rebateRequest.rebateRequestLoaded.SCNT);
      let SCNTnew = parseInt(control.value);
      if (SCNTnew > oldSCNT) {
        return { 'SCNTInvalid': true };
      }
      else {
        return null;
      }
    }
    else{
      return null;
    }
  }
  onRebateRequestLoadedFlag(flag: boolean) {
    if (flag) {
      //Enable Loader
      this.globalServices.IsLoaderEnabled = true;
      this.rebateRequestId = this.rebateRequest.rebateRequestLoaded.Id;
      this.rebateRequest.showOptionDev = false;
      this.rebateRequest.editModeAdmin = true;
      this.sailDirections = this.rebateRequest.sailDirections;
      this.shipIMONO = this.rebateRequest.rebateRequestLoaded.IMONo;
      this.rebateSCNT = this.rebateRequest.rebateRequestLoaded.SCNT;

      // if(this.rebateRequestId && this.rebateRequestId != ""){
      //   this.noOfLoadingLookups = 4;
      //   this.loadMeasurementDecisionRebateRequest();
      // }
      // this.loadLookups();
      this.loadInitialData();
    }
  }
  loadInitialData(): void {
    this.loadMeasurementDecisionRebateRequest();
    this.loadLookups();
  }
  //Form
  buildMeasurementCommitteeDecisionForm(): void {
    this.measurementCommitteeDecisionForm = this.formBuilder.group({
      LongHaulRequestMeasurementCommitteeDecisionId: [''],
      LongHaulRequestMeasurementCommitteeAccept: this.formBuilder.group({
        SCID: ['', [Validators.pattern("^[0-9]*$")]],
        VesselTypeId: [null, [Validators.required]],
        LastTransitDate: [''],
        RebateOnlastTransit: [''],
        RebateValue: [''],
        PortOfOrigin: [''],
        PortOfDestination: [''],
        //SCNT: ['', [Validators.pattern("^[0-9]{2,2}$")]],
        //SCNT: ['', [Validators.pattern("^[1-9][0-9]*([.][0-9]{1,2}|)$")]],
        SCNT: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,5}([.][0-9]{1,2}|)$"), this.validateSCNT]],
        DW: ['', [Validators.required, Validators.pattern("^[0-9]{1,6}$"), Validators.maxLength(50)]],
        DirectionId:[null, [Validators.required]],
        //NumberOfTugs: ['', [Validators.pattern("^[0-9]+$")]],
        RateId: [null, [Validators.required]],
        ExtraCost: [''],
        NotesAndComments: [''],
       // TugsLongHaulRequestMeasurementCommitteeDecisionAccept: ['']
        //TugsLongHaulRequestMeasurementCommitteeDecisionAccept: this.formBuilder.array([this.buildTugsForm()])
      }),
      RequireModificationNotesAndComments: [''],
      RejectionReason: ['']
    });
  }


 /* buildTugsForm(): FormGroup {
    return this.formBuilder.group({
      TugId: [''],
      NumberOfTugs: ['']
    });
  }*/
 /* tugValueChange(event) {
    let totalNumber = 0;
    for (let i = 0; i < this.tugsLongHaulRequestMeasurementCommitteeDecisionAccept.length; i++) {
      totalNumber += this.tugsLongHaulRequestMeasurementCommitteeDecisionAccept[i].NumberOfTugs;
    }
    this.numberOfTugs = totalNumber;
  }*/
  //Defaults
  setDefaults(): void {
    this.buildMeasurementCommitteeDecisionForm();
  }
  //Lookups
  loadLookups(): void {
   // this.loadTugs();
    this.loadRates();
    this.loadRelatedRequests();
    this.loadVesselTypes();
    this.loadCountries();
  }
  loadCountries(): void {
    this.lookupService.getCountries().subscribe(
      data => this.countries = data.Data as Country[],
      () => console.log("Something went wrong!!"),
      () => this.loadCountriesCompleted()
    );
  }
  loadCountriesCompleted(): void {
    this.countries.sort((a, b) => (a.NameEN > b.NameEN) ? 1 : -1);
    this.checkLoadedLookups();
  }
  loadVesselTypes(): void {
    this.lookupService.getVesselTypes().subscribe(
      data => this.vesselTypes = data.Data as VesselType[],
      () => console.log("Something went wrong!!"),
      () => this.loadVesselTypesCompleted()
    );
  }
  loadVesselTypesCompleted(): void {
    let otherVesselType: VesselType = this.vesselTypes.filter(v => v.NameEN == 'Other Vessel')[0];
    this.vesselTypes = this.vesselTypes.filter(v => v.NameEN != 'Other Vessel');
    this.vesselTypes.sort((a, b) => (a.NameEN > b.NameEN) ? 1 : -1);
    this.vesselTypes.push(otherVesselType);
    this.checkLoadedLookups();
  }
  /*loadTugs(): void {
    this.lookupService.getTugs().subscribe(
      data => this.tugs = data.Data as GenericLookup[],
      () => console.log("Something went wrong!!"),
      () => this.loadTugsCompleted()
    );
  }
  loadTugsCompleted(): void {
    for (let i = 0; i < this.tugs.length; i++) {
      this.tugsLongHaulRequestMeasurementCommitteeDecisionAccept[i] = new TugsLongHaulRequestMeasurementCommitteeDecisionAccept();
      this.tugsLongHaulRequestMeasurementCommitteeDecisionAccept[i].LongHaulRequestMeasurementCommitteeAcceptId = this.rebateRequestId;
      this.tugsLongHaulRequestMeasurementCommitteeDecisionAccept[i].TugId = this.tugs[i].Id;
      this.tugsLongHaulRequestMeasurementCommitteeDecisionAccept[i].TugNameEN = this.tugs[i].NameEN;
      this.tugsLongHaulRequestMeasurementCommitteeDecisionAccept[i].NumberOfTugs = 0;
    }
    this.checkLoadedLookups();
  }*/
  loadRates(): void {
    this.lookupService.getRates().subscribe(
      data => this.rates = data.Data as GenericLookup[],
      () => console.log("Something went wrong!!"),
      () => this.loadRatesCompleted()
    );
  }
  loadRatesCompleted(): void {
    this.checkLoadedLookups();
  }
  loadRelatedRequests(): void {
    this.longHaulService.getRelatedRequests(this.shipIMONO, this.rebateRequestId).subscribe(
      data => this.getRelatedRequestsResponse = data,
      () => console.log("Something went wrong!!"),
      () => this.loadRelatedRequestsCompleted()
    );
  }
  loadRelatedRequestsCompleted(): void {
    if (this.getRelatedRequestsResponse.Success) {
      this.getRelatedRequestsObjects = this.getRelatedRequestsResponse.Data as RelatedRequests[];
     /* this.getRelatedRequestsObjects.forEach(element => {
        if(element.Status1.Id==1088){
          element.Status1.StatusEN = "Normal Tolls";
        }
      }
      );*/
      this.checkLoadedLookups();
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      //Enable Confirmation
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  checkLoadedLookups(): void {
    this.noOfLoadedLookups++;
    if (this.noOfLoadedLookups == this.noOfLoadingLookups) {
      if (this.formMode == FormMode.DetailsAccept || this.formMode == FormMode.DetailsReject)
        this.fillMeasurementAcceptedRequestObject();
      this.measurementCommitteeDecisionLoadedFlag.emit(true);
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  loadMeasurementDecisionRebateRequest(): void {
    this.longHaulService.getMeasurementDecisionRebateRequest(this.rebateRequestId).subscribe(
      data => this.getMeasurementAcceptedRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.loadMeasurementDecisionRebateRequestCompleted()
    );
  }
  loadMeasurementDecisionRebateRequestCompleted(): void {
    if (this.getMeasurementAcceptedRebateRequestResponseObject.Success) {
      this.longHaulRequestMeasurementCommitteeDecision = this.getMeasurementAcceptedRebateRequestResponseObject.Data as LongHaulRequestMeasurementCommitteeDecision;
      this.longHaulRequestMeasurementCommitteeAccept = this.longHaulRequestMeasurementCommitteeDecision.LongHaulRequestMeasurementCommitteeAccept;
      if (this.longHaulRequestMeasurementCommitteeDecision.DecisionId != null) {
        if (this.longHaulRequestMeasurementCommitteeDecision.DecisionId == +Decision.Accept) {
          this.formMode = FormMode.DetailsAccept;
        } else if (this.longHaulRequestMeasurementCommitteeDecision.DecisionId == +Decision.Reject) {
          this.formMode = FormMode.DetailsReject;
        }
      }
      this.checkLoadedLookups();
    } else {
      this.submitConfirmationMode = ConfirmationMode.Error;
      //Enable Confirmation
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  loadMeasurementDecisionAcceptRebateRequest(): void {
    this.longHaulService.getMeasurementAcceptRebateRequest(this.rebateRequest.rebateRequestLoaded.IMONo).subscribe(
      data => this.longHaulRequestMeasurementCommitteeAcceptLoadedResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.loadMeasurementDecisionAcceptRebateRequestCompleted()
    );
  }
  loadMeasurementDecisionAcceptRebateRequestCompleted(): void {
    if (this.longHaulRequestMeasurementCommitteeAcceptLoadedResponseObject.Success) {
      this.longHaulRequestMeasurementCommitteeAcceptLoaded = this.longHaulRequestMeasurementCommitteeAcceptLoadedResponseObject.Data as LongHaulRequestMeasurementCommitteeAccept;
      if (this.longHaulRequestMeasurementCommitteeAcceptLoaded != null && this.formMode != FormMode.DetailsAccept && this.formMode != FormMode.DetailsReject) {
        //Fill Accept Form Control Values
        this.isRebateOnlastTransit = this.longHaulRequestMeasurementCommitteeAcceptLoaded.RebateOnlastTransit;
        let directionId = this.longHaulRequestMeasurementCommitteeAcceptLoaded.DirectionId;
        this.measurementCommitteeDecisionForm.controls['LongHaulRequestMeasurementCommitteeAccept'].patchValue({
          SCID: this.longHaulRequestMeasurementCommitteeAcceptLoaded.SCID,
          LastTransitDate: new Date(this.longHaulRequestMeasurementCommitteeAcceptLoaded.LastTransitDate),
          RebateOnlastTransit: JSON.stringify(this.longHaulRequestMeasurementCommitteeAcceptLoaded.RebateOnlastTransit),
          RebateValue: this.longHaulRequestMeasurementCommitteeAcceptLoaded.RebateValue,
          PortOfOrigin: this.longHaulRequestMeasurementCommitteeAcceptLoaded.PortOfOrigin,
          PortOfDestination: this.longHaulRequestMeasurementCommitteeAcceptLoaded.PortOfDestination,
          SCNT: this.longHaulRequestMeasurementCommitteeAcceptLoaded.SCNT,
          DW: this.longHaulRequestMeasurementCommitteeAcceptLoaded.DW,
          //DirectionId: directionId,
          RateId: this.longHaulRequestMeasurementCommitteeAcceptLoaded.RateId,
          VesselTypeId: this.longHaulRequestMeasurementCommitteeAcceptLoaded.VesselTypeId,
          ExtraCost: this.longHaulRequestMeasurementCommitteeAcceptLoaded.ExtraCost,
          NotesAndComments: this.longHaulRequestMeasurementCommitteeAcceptLoaded.NotesAndComments
        });
        this.measurementCommitteeDecisionForm.controls['LongHaulRequestMeasurementCommitteeAccept'].updateValueAndValidity();
        this.measurementCommitteeDecisionForm.controls['LongHaulRequestMeasurementCommitteeAccept'].get('DirectionId').updateValueAndValidity();
        //Fill Tugs
        this.numberOfTugs = +this.longHaulRequestMeasurementCommitteeAcceptLoaded.NumberOfTugs;
        for (let i = 0; i < this.longHaulRequestMeasurementCommitteeAcceptLoaded.TugsLongHaulRequestMeasurementCommitteeDecisionAccept.length; i++) {
          if (this.tugsLongHaulRequestMeasurementCommitteeDecisionAccept.filter(t => t.TugId == this.longHaulRequestMeasurementCommitteeAcceptLoaded.TugsLongHaulRequestMeasurementCommitteeDecisionAccept[i].TugId)[0] != undefined) {
            this.tugsLongHaulRequestMeasurementCommitteeDecisionAccept.filter(t => t.TugId == this.longHaulRequestMeasurementCommitteeAcceptLoaded.TugsLongHaulRequestMeasurementCommitteeDecisionAccept[i].TugId)[0].NumberOfTugs = this.longHaulRequestMeasurementCommitteeAcceptLoaded.TugsLongHaulRequestMeasurementCommitteeDecisionAccept[i].NumberOfTugs;
          }
        }
        this.formMode = FormMode.Edit;
      }
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      //Enable Confirmation
      this.isRequestSucceeded = true;
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  fillMeasurementAcceptedRequestObject(): void {

    if (this.formMode == FormMode.DetailsAccept) {
      //Open Accept Form
      this.isAccept = true;
    } else if (this.formMode == FormMode.DetailsReject) {
      //Open Reject Form
      this.isReject = true;
    }
    //Disable Form
    this.measurementCommitteeDecisionForm.disable();
    //Fill Form Decision
    this.measurementCommitteeDecisionForm.patchValue({
      LongHaulRequestMeasurementCommitteeDecisionId: this.longHaulRequestMeasurementCommitteeDecision.DecisionId.toString()
    });
    if (this.formMode == FormMode.DetailsAccept) {
      this.isRebateOnlastTransit = this.longHaulRequestMeasurementCommitteeAccept.RebateOnlastTransit;
      //Fill Accept Form Control Values
      let directionId = this.longHaulRequestMeasurementCommitteeAccept.DirectionId;
      this.measurementCommitteeDecisionForm.controls['LongHaulRequestMeasurementCommitteeAccept'].patchValue({
        SCID: this.longHaulRequestMeasurementCommitteeAccept.SCID,
      // LastTransitDate: this.longHaulRequestMeasurementCommitteeAccept.LastTransitDate != null && this.longHaulRequestMeasurementCommitteeAccept.LastTransitDate != "" ?
        //  this.datepipe.transform(this.longHaulRequestMeasurementCommitteeAccept.LastTransitDate, 'dd-MM-yyyy') : null,

        LastTransitDate: this.longHaulRequestMeasurementCommitteeAccept.LastTransitDate != null ? new Date(this.longHaulRequestMeasurementCommitteeAccept.LastTransitDate) : null,
        RebateOnlastTransit: JSON.stringify(this.longHaulRequestMeasurementCommitteeAccept.RebateOnlastTransit),
        RebateValue: this.longHaulRequestMeasurementCommitteeAccept.RebateValue,
        PortOfOrigin: this.longHaulRequestMeasurementCommitteeAccept.PortOfOrigin,
        PortOfDestination: this.longHaulRequestMeasurementCommitteeAccept.PortOfDestination,
        SCNT: this.longHaulRequestMeasurementCommitteeAccept.SCNT,
        DW: this.longHaulRequestMeasurementCommitteeAccept.DW,
        DirectionId: directionId,
        RateId: this.longHaulRequestMeasurementCommitteeAccept.RateId,
        VesselTypeId: this.longHaulRequestMeasurementCommitteeAccept.VesselTypeId,
        ExtraCost: this.longHaulRequestMeasurementCommitteeAccept.ExtraCost,
        NotesAndComments: this.longHaulRequestMeasurementCommitteeAccept.NotesAndComments
      });
      this.measurementCommitteeDecisionForm.controls['LongHaulRequestMeasurementCommitteeAccept'].updateValueAndValidity();
      this.measurementCommitteeDecisionForm.controls['LongHaulRequestMeasurementCommitteeAccept'].get('DirectionId').updateValueAndValidity();
      //Fill Tugs
      this.numberOfTugs = +this.longHaulRequestMeasurementCommitteeAccept.NumberOfTugs;
      for (let i = 0; i < this.longHaulRequestMeasurementCommitteeAccept.TugsLongHaulRequestMeasurementCommitteeDecisionAccept.length; i++) {
        this.tugsLongHaulRequestMeasurementCommitteeDecisionAccept.filter(t => t.TugId == this.longHaulRequestMeasurementCommitteeAccept.TugsLongHaulRequestMeasurementCommitteeDecisionAccept[i].TugId)[0].NumberOfTugs = this.longHaulRequestMeasurementCommitteeAccept.TugsLongHaulRequestMeasurementCommitteeDecisionAccept[i].NumberOfTugs;
      }
    } else if (this.formMode == FormMode.DetailsReject) {
      this.measurementCommitteeDecisionForm.patchValue({
        RejectionReason: this.longHaulRequestMeasurementCommitteeDecision.RejectionReason
      });
    }
    this.cd.detectChanges();
  }
  //Submit
  submit(): void {
    this.isFormSubmitted = true;
    const formValidControls = this.measurementCommitteeDecisionControls.nativeElement.querySelectorAll('.ng-invalid');
    if (!this.measurementCommitteeDecisionForm.valid && formValidControls.length > 0) {
      if (formValidControls[0].innerHTML.indexOf('<h4 class="section-title">Accept</h4>') > -1)
        formValidControls[1].focus();
      else
        formValidControls[0].focus();
    } else {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      this.measurementCommitteeDecisionObject = this.measurementCommitteeDecisionForm.value;
      this.setDateTimeDefault()
      this.measurementCommitteeDecisionObject.LongHaulRequestId = this.rebateRequestId;
      this.measurementCommitteeDecisionObject.MeasurementCommitteeAdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
      //this.measurementCommitteeDecisionObject.MeasurementCommitteeAdminEmail = "ahmed.abdelgwad@linkdev.com";
      if (this.measurementCommitteeDecisionForm.controls['LongHaulRequestMeasurementCommitteeDecisionId'].value == Decision.Accept) {
        this.measurementCommitteeDecisionObject.LongHaulRequestMeasurementCommitteeAccept.NumberOfTugs = this.numberOfTugs;
        this.measurementCommitteeDecisionObject.LongHaulRequestMeasurementCommitteeAccept.TugsLongHaulRequestMeasurementCommitteeDecisionAccept = this.tugsLongHaulRequestMeasurementCommitteeDecisionAccept;
      }
      if (this.rebateRequestId && this.rebateRequestId != "")
        this.submitMeasurementCommitteeDecision();
    }
  }
  submitMeasurementCommitteeDecision(): void {
    this.longHaulService.submitMeasurementCommitteeDecision(this.measurementCommitteeDecisionObject).subscribe(
      data => this.submitMeasurementCommitteeDecisionResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitMeasurementCommitteeDecisionCompleted()
    );
  }
  submitMeasurementCommitteeDecisionCompleted(): void {
    if (!this.submitMeasurementCommitteeDecisionResponseObject.Success) {
      //Enable Error / Warning

      if (this.submitMeasurementCommitteeDecisionResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if (this.submitMeasurementCommitteeDecisionResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
        else
        {
          this.submitConfirmationMode = ConfirmationMode.Error;
        }
    }

    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
    //Enable Confirmation
    this.isRequestSucceeded = true;
  }
  //Related Requests
  viewRelatedRequests(): void {
    //this.showRelatedRequests = true;
  }
  relatedRequestDetails(relatedRequestIndex: number): void {
    localStorage.setItem('lsRebateRequestId', this.getRelatedRequestsObjects[relatedRequestIndex].Id);
    this.cookieService.set('RelatedRequestId',this.getRelatedRequestsObjects[relatedRequestIndex].Id);

    if (this.getRelatedRequestsObjects[relatedRequestIndex].serviceName == 'Circulars') {

      window.open('#/CircularRequest/BaseRequestDetails', '_blank');
    }
    else if (this.getRelatedRequestsObjects[relatedRequestIndex].serviceName == 'Long Haul') {

      window.open('#/RebateRequest/BaseRequestDetails', '_blank');
    }
  }

  later(): void {
    this.router.navigateByUrl('/myTasks');
  }
  setDateTimeDefault()
  {//Fix Last transit date time issue
    var defaultTimeForDates =  ",12:00:00 PM";
    this.measurementCommitteeDecisionObject.LongHaulRequestMeasurementCommitteeAccept.LastTransitDate = this.measurementCommitteeDecisionObject.LongHaulRequestMeasurementCommitteeAccept.LastTransitDate != null && this.measurementCommitteeDecisionObject.LongHaulRequestMeasurementCommitteeAccept.LastTransitDate!= "" ? new Date(this.measurementCommitteeDecisionObject.LongHaulRequestMeasurementCommitteeAccept.LastTransitDate.toLocaleDateString() + defaultTimeForDates) : null;
  }
  //#endregion
}

enum Decision {
  Accept = "1",
  RequireModification = "2",
  Reject = "3"
}

enum FormMode {
  New = 1,
  Edit = 2,
  DetailsAccept = 3,
  DetailsReject = 4
}

enum ConfirmationMode {
  Success = 1,
  Warning = 2,
  Error = 3
}
